// Récupère les liens des menus publiés depuis l'app IA Studio via l'API REST
// Firestore (lecture publique). Aucune dépendance : fetch natif + parsing du
// format REST typé. Valeurs publiques (clé web Firebase).

const PROJECT_ID = "aistudio-3fde9";
const API_KEY = "AIzaSyDveboo1IR3EhTmePFVxaU9uoWx6xNyOPw";
const DOC_URL = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents/site/lephoenix?key=${API_KEY}`;

/** Les 4 emplacements pilotés depuis l'app (Les Vins / Wines exclus). */
export const SLOTS = ["carteFr", "carteEn", "boissonsFr", "boissonsEn"];

/** Extrait { slot: url } d'une réponse REST Firestore. Emplacements sans url ignorés. */
export function parsePublishedDoc(json) {
  const out = {};
  const fields = (json && json.fields) || {};
  for (const slot of SLOTS) {
    const f = fields[slot];
    const url =
      f && f.mapValue && f.mapValue.fields && f.mapValue.fields.url && f.mapValue.fields.url.stringValue;
    if (url) out[slot] = url;
  }
  return out;
}

/** Lit le doc Firestore et renvoie { slot: url }. {} en cas d'erreur / réseau KO. */
export async function fetchPublishedLinks() {
  try {
    const res = await fetch(DOC_URL);
    if (!res.ok) return {};
    return parsePublishedDoc(await res.json());
  } catch {
    return {};
  }
}
